import { makeStyles } from '@material-ui/core/styles';
import worklogStyles from '../styles';

export default makeStyles(worklogStyles);
